import React, { useRef, useEffect, useState } from 'react'
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarafiyat } from '../../../../../assets/zarafiyat.svg'
import QrSvg from '@wojtekmaj/react-qr-svg'
import tshirtlogo from '../../../../../assets/tshirtinfo.svg'
import QRCodeStyling from 'qr-code-styling'
import { ReactComponent as MySVG } from '../../../../../assets/fsc.svg'
import { ReactComponent as MySVG2 } from '../../../../../assets/logolar-02.svg'
import { ReactComponent as MySVG3 } from '../../../../../assets/logolar-03.svg'
import { ReactComponent as MySVG4 } from '../../../../../assets/logolar-04.svg'
import { ReactComponent as MySVG5 } from '../../../../../assets/logolar-05.svg'
import { ReactComponent as MySVG6 } from '../../../../../assets/Varlık1.svg'
import { ReactComponent as ALARM } from '../../../../../assets/alarm (1).svg'

import { ReactComponent as MySVG7 } from '../../../../../assets/pricetopsvg/pricehomebathroom.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/pricetopsvg/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/pricetopsvg/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/pricetopsvg/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/pricetopsvg/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/pricetopsvg/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/pricetopsvg/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'

import { ReactComponent as MySVG18 } from '../../../../../assets/altbestlogo.svg'
import { ReactComponent as MyLogoHarman } from '../../../../../assets/altlogoharman.svg'
import { ReactComponent as ZaraLogoNewFullfill } from '../../../../../assets/zarahome/fscfullfilnew.svg'


import { ReactComponent as MySVG19 } from '../../../../../assets/talla.svg'
import { ReactComponent as MySVG20 } from '../../../../../assets/usuk.svg'
import { ReactComponent as MySVG249 } from '../../../../../assets/justus.svg'
import { ReactComponent as MySVG250 } from '../../../../../assets/justuk.svg'
import { ReactComponent as MySVG21 } from '../../../../../assets/usamexuk.svg'
import { ReactComponent as MySVG22 } from '../../../../../assets/lineline.svg'
import { ReactComponent as MySVG2900 } from '../../../../../assets/RDOLAR.svg'
import { ReactComponent as MySVGTry } from '../../../../../assets/55110.svg'
import { useAuth } from 'store/client/authStore'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg';
import { ReactComponent as BlackDenim } from '../../../../../assets/black-denimwear.svg' // SVG'yi React bileşeni olarak içe aktarma

import { ReactComponent as ZaraFscrr } from '../../../../../assets/zarahome/newfscrr.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/zarahome/newfsctm.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/zarahome/newfsctmpaper.svg'
import { ReactComponent as ZaraGeneralBack } from '../../../../../assets/zarahome/generalback.svg'
import { ReactComponent as ALARMHOME } from '../../../../../assets/zarahome/ALARMHOME.svg'

import { ReactComponent as Ceramic } from '../../../../../assets/zarahome/ceramic.svg'


import { ReactComponent as Path689 } from '../../../../../assets/zarahome/path689.svg'


import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { LiaCircleSolid } from 'react-icons/lia'
import { BiSolidCircle } from 'react-icons/bi'
import DynamicShrinkText from './DynamicShrinkText'
import DynamicTextLeftt from './DynamicShrinkLefft'
import QRCodeComponent from './qrcodecomponent'
import RenderIndoItems from './RenderIndoItems'
import RenderIndoItemsCM from './RenderIndoItemsCM'
import DynamicTextKids from './DynamicTextKids'
import RenderIndoItemsKids from './RenderIndoItemsKıds'


export default function Page1({
  sizeData,
  renderShape,
  Path1,
  selectColor = 0,
  barcodeValue,
  qrcodeValue,
  data,
  indo,
  inx,
  szrgrp,
  integerpart3,
  currencysymbol3,
  integerpart4,
  currencysymbol4,
  decimalpart3,
  decimalpart4,
  rifd,
  SouthAmerica,
  harmacn,
  cardType,
  homeProducts,
  x,
  y,

}) {
  const divRef = useRef(null)
  const textRef = useRef(null)
  const [scaleX, setScaleX] = useState(1)
  const department = data.department
  const barcodeRef = useRef(null);
  const [modifiedSvgText, setModifiedSvgText] = useState("");
  const [topValue, settopValue] = useState(16) 
  const [leftValue, setleftValue] = useState(97.9)  
  const [isLeather, setisLeather] = useState(false)  
const [texttt, setTexttt] = useState("")

console.log("dataaaaaaaaaaaaaax12311111",sizeData)

  // Bölmek için "/" karakterini kullan
  const selectedFscType = data.company?.fsctype;

  const leatherTypes = [
    "BUFFALO FURSKIN", "BUFFALO LEATHER", "CALF FURSKIN", "COLT LEATHER",
    "COW FURSKIN", "GOAT LEATHER", "HORSE LEATHER", "LAMB FURSKIN",
    "LAMBSKIN", "PIG FURSKIN", "PIG LEATHER", "RABBIT LEATHER",
    "SHEEP FURSKIN", "SHEEP LEATHER"
  ]

  const [brand, category, subCategory] = department ? department.split(' / ') : ['', '', '']
 
  const filteredIndo = indo.filter((item) => item.amount !== '')
  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  const FSC_COMPONENTS = {
    fscrr: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
    fsctm: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
    fsctmpaper: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
  };

  const SelectedComponent = FSC_COMPONENTS[selectedFscType];

  useEffect(() => {
    if (category) {
      setCurrentShape(category)
    }
  }, [category])

  const handleSvgGenerated = (svgText) => {
    setModifiedSvgText(svgText);
  };
  function getProductTextById(id) {
    const matchedProduct = homeProducts.find(item => item.id === id);

    console.log("sizeData.description",sizeData.description)


    return matchedProduct ? matchedProduct.text : "";


  }
  
  useEffect(() => {

    // Belirtilen seçiciyle DOM öğesini yakalama
    const textElement = document.querySelector(
      '#root > div.min-h-screen.font-poppins > div > div:nth-child(3) > div:nth-child(1) > div > div > div > div:nth-child(3) > div:nth-child(3) > div.printable > div > div > div > div.tracking-\\[\\.02rem\\] > svg > g > text'
    );

    if (textElement) {
      // Margin top değerini güncelle
      //textElement.style.marginTop = '-10px ';
    } else {
    }
  }, []); // Sadece bileşen yüklendiğinde bir kez çalışacak




  const renderSVG = (integer3, decimal3, integer4, decimal4) => {
    console.log("Values received:", { integer3, decimal3, integer4, decimal4 });
    console.log("SUBCATEGORYY",subCategory);
    // Değerleri stringe çevirip kontrol ediyoruz
    const isInteger3Valid = String(integer3).trim() !== '';
    const isDecimal3Valid = String(decimal3).trim() !== '';
    const isInteger4Valid = String(integer4).trim() !== '';
    const isDecimal4Valid = String(decimal4).trim() !== '';
  if(SouthAmerica)
  {
    return <MySVG2900 width="23.256mm" height="14.496mm" />;
    

  }
  else{
    switch (true) {
      case isInteger3Valid && isDecimal3Valid && isInteger4Valid && isDecimal4Valid:
        console.log("Case 1: All values are present (integer3, decimal3, integer4, decimal4)");
        return <MySVG20 width="21.256mm" height="14.496mm" />;
      case isInteger3Valid && isDecimal3Valid && !isInteger4Valid :
        console.log("Case 2: Only integer3 and decimal3 are present, integer4 and decimal4 are missing");
        return <MySVG249 width="21.256mm" height="14.496mm" />;
      case isInteger4Valid && isDecimal4Valid && !isInteger3Valid:
        console.log("Case 3: Only integer4 and decimal4 are present, integer3 and decimal3 are missing");
        return <MySVG250 width="21.256mm" height="14.496mm" />;
      default:
        console.log("Default Case: None of the conditions are met", { integer3, decimal3, integer4, decimal4 });
        return null; // Hiçbir koşul sağlanmazsa hiçbir şey döndürme
    }
  }
  

  };
 /* 
  <div style={{position:"absolute",left:12,top:-2}}>
  <MySVGTry style={{width:"55.2mm",height:"110.2mm"}}/>

  </div>
  */


  useEffect(() => {
    const adjustScale = () => {
      if (divRef.current && textRef.current) {
        const containerWidth = divRef.current.offsetWidth
        const textWidth = textRef.current.offsetWidth

        if (textWidth > containerWidth) {
          setScaleX(containerWidth / textWidth)
        } else {
          setScaleX(1)
        }
      }
    }

    adjustScale()
    window.addEventListener('resize', adjustScale) // Dinamik ekran boyutu için
    return () => window.removeEventListener('resize', adjustScale)
  }, [filteredIndo, inx])

  

  const valueBasedOnInx = indexedIndo[inx]

  const [currentShape, setCurrentShape] = useState(null)

  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'
  let shape

  const renderCardTypeContent = () => {
    switch (cardType) {
      case "General Textile":
        return (

          <div>
             
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 13,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                    <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
                )}
              </div>
    
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
     
              <div
  className="
    absolute text-[4pt] leading-[4.1pt] text-justify pdf-force
   
  "
  style={{
    top: 160,
    left: 34.8,
    width: '174px',              // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    unicodeBidi: 'plaintext',
  }}
>{getProductTextById(sizeData.description)}</div>
              <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
            
              <div></div>
           
    

     
         
    
              <div style={{position:"absolute",top:121.8,height:29,left:39.4,width:"164px",display:"flex",justifyContent:"center",alignItems:"center"}}>                  <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                     marginLeft:3.8
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>
      
             
              <div style={{ position: 'absolute', top: 8.5, left: 34.8  }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

         
     
              <div
  style={{
    position: 'absolute',
    top: -15,
    right: rifd ? -44 : -37
  }}
>
  <QRCodeComponent
    barcodeValue={qrcodeValue}
    onSvgGenerated={handleSvgGenerated}
  />
  {modifiedSvgText && (
    <div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
  )}
</div>

      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
      case "Special measures":
        return (
          <div>
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 13,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
                )}
              </div>
              <div
  className="
    absolute text-[4pt] leading-[4.1pt] text-justify pdf-force
   
  "
  style={{
    top: 160,
    left: 34.8,
    width: '174px',              // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    unicodeBidi: 'plaintext',
  }}
>{getProductTextById(sizeData.description)}</div>
          <div
                style={{
                  position: 'absolute',
                  top: 7.5,
                  left: 107.2,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    <div style={{ position: 'absolute', top: 118.6, left: -67,width:165}}>
            <div
              style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
            >

<RenderIndoItemsCM indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />


            </div>
          </div>
   
              </div>
           
              <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
              
              <div></div>
           
    

     
         
    
             
              <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

         
     
              <div style={{   position: 'absolute',
    top: -15,
    right: rifd ? -44 : -37 }}>
                <QRCodeComponent  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
      case "Adult apparel":
        return (

          <div>
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
            <DynamicShrinkText
            filteredIndo={filteredIndo}
            inx={inx}
            szrgrp={szrgrp}
            valueBasedOnInx={valueBasedOnInx}
            referance={referance}
            brand={brand}
            category={category}
            subCategory={subCategory}
          />


           <div style={{ position: 'absolute', top: 164, left: 28,width:"85%" }}>
            <div
              style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
            >

<RenderIndoItems indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />


            </div>
          </div>
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 13,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
                )}
              </div>
    
              <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
    
              <div></div>
           
    

     
       
    
                  <div style={{position:"absolute",top:122,height:29,left:40,width:"165px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                  <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:5.4
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>
      
             
              <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

         
     
              <div style={{   position: 'absolute',
    top: -15,
    right: rifd ? -44 : -37 }}>
                <QRCodeComponent  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
        
        
        
        case "Kids apparel":
        return (

          <div>
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>

            <div style={{position:"absolute",top:122,height:29,left:40,width:"165px",display:"flex",justifyContent:"center",alignItems:"center"}}>

         
            <DynamicTextKids
            filteredIndo={filteredIndo}
            inx={inx}
            szrgrp={szrgrp}
            valueBasedOnInx={valueBasedOnInx}
            referance={referance}
            brand={brand}
            category={category}
            subCategory={subCategory}
          />
   </div>

           <div style={{ position: 'absolute', top: 164, left: 28,width:"85%" }}>
            <div
              style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
            >

      <RenderIndoItemsKids indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />


            </div>
          </div>
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 13,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
                )}
              </div>
    
              <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
    
              <div></div>
           
    

     
       
    

             
              <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

         
     
              <div style={{   position: 'absolute',
    top: -15,
    right: rifd ? -44 : -37 }}>
                <QRCodeComponent  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
      case "Object":
        return (
          <div>
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 13,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
                )}
              </div>
    
    <div className="text-[4pt] leading-[4.1pt] text-justify pdf-force" style={{ position: 'absolute', top:157.4, left: 34.6, // 86mm biraz dar olabilir, 1–2 mm tolerans ver
 
    fontWeight: '400',
    fontsize:4,
    width:"175px",
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    unicodeBidi: 'plaintext', }}>
    
    <div style={{display: 'block', marginBottom: '5px'}}>{getProductTextById(sizeData.description)}</div>
    <div style={{display: 'block',marginBottom: '5px'}}>ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516 FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ: 13.144.185/0001-50 MODA HOME S.A.S. SIC 900.495.729 （株）ITXジャ パン (0120-914-075) #RN 138445 ZARA HOME CANADA INC. 1550 MONTRÉAL, QUEBEC, H3B 4G7 MA-MAROC : Sté RTW MAROC IF : 1642262.</div>
    <div style={{ display: 'block' }}>
  {data.country.translate
    .map((item) => item.translation)
    .join(' / ')}
</div>
    
    </div>
    <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
              <div></div>
           
    

     
         
    
                  <div style={{position:"absolute",top:122,height:29,left:40,width:"165px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                  <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:5.4
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>
      
             
              <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

    
         
     
              <div style={{   position: 'absolute',
    top: -15,
    right: rifd ? -44 : -37 }}>
                <QRCodeComponent  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
        case "Basket":
          return (
            <div>
            <div>
              <div>
              <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
              <div
                  style={{
                    position: 'absolute',
                    top: 9,
                    right: 13,
      
                    justifyContent: 'center',
                    display: 'grid',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  {rifd && (
                    <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
                  )}
                </div>
      
                <div className="text-[3.7pt] leading-[4.1pt] text-justify pdf-force" style={{ position: 'absolute', top:157.4, left: 34.6, // 86mm biraz dar olabilir, 1–2 mm tolerans ver
    fontWeight: '400',
    fontsize:4,
    width:"175px",
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    unicodeBidi: 'plaintext', }}>
    
    <div style={{display: 'block', marginBottom: '5px'}}>{getProductTextById(sizeData.description)}</div>
    <div style={{display: 'block',marginBottom: '5px'}}>ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516 FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ: 13.144.185/0001-50 MODA HOME S.A.S. SIC 900.495.729 （株）ITXジャ パン (0120-914-075) #RN 138445 ZARA HOME CANADA INC. 1550 MONTRÉAL, QUEBEC, H3B 4G7 MA-MAROC : Sté RTW MAROC IF : 1642262.</div>
    <div style={{ display: 'block' }}>
  {data.country.translate
    .map((item) => item.translation)
    .join(' / ')}
</div>
    
    </div>
    <div
                style={{
                  position: 'absolute',
                  top: 7.5,
                  left: 107.2,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
          
      <div style={{ position: 'absolute', top: 120.6, left: -67,width:165}}>
              <div
                style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
              >
  
  <RenderIndoItemsCM indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />
  
  
              </div>
            </div>
      

      
                </div>
          
                <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
                <div></div>
             
      
  
       
           
      
               
                <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
                {SelectedComponent && (
        <SelectedComponent.component
          width={SelectedComponent.width}
          height={SelectedComponent.height}
        />
      )}
      </div>

      
           
       
                <div style={{   position: 'absolute',
    top: -15,
    right: rifd ? -44 : -37 }}>
                  <QRCodeComponent  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                  {modifiedSvgText && (
                    <div
        dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
      
      ></div>
      
            )}
                </div>
        
             
         
                <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                  <Barcode
                    value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                    format="ITF14"
                    width={0.921}
                    height={25.9}
                    marginLeft={1}
                    marginRight={1}
                    marginTop={1}
                    marginBottom={1}  
                    background="transparent"
                    lineColor={isBlack ? '#ffffff' : '#000000'}
                    textMargin={0}
                    fontSize={8} // 7pt yaklaşık olarak 9px
                    font="Arial"
                  />
                </div>
      
       
                <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                      ART
                    </p>  
                    <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                      .:
                    </p>
                    <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                    {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                    </p>
                  </div>{' '}
                </div>
              </div>
            </div>
          </div>
          );
          
          
          case "Food contact":
            return (
              <div>
              <div>
                <div>
                <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
                <div
                    style={{
                      position: 'absolute',
                      top: 9,
                      right: 13,
        
                      justifyContent: 'center',
                      display: 'grid',
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                  >
                    {rifd && (
                      <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
                    )}
                  </div>
        
        <div className="text-[4.7pt] leading-[4.6pt] text-justify" style={{ position: 'absolute', top:157.4, left: 34.6, // 86mm biraz dar olabilir, 1–2 mm tolerans ver
        fontFamily: 'arial-narrow',
        fontWeight: '400',
        fontsize:4,
        width:"175px",
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal', }}>
        
        <div className='text-[4.5pt]' style={{display: 'block', marginTop: '4px',marginBottom:6, letterSpacing:"-0.5px",textAlign:"center"}}>PIEL BOVINA / COW LEATHER / CUIR DE VACHETTE / 牛皮革 / 牛皮 / 소가죽</div>
        <div style={{display: 'block',marginBottom: '5px',letterSpacing:"-0.3px"}}>ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516 FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ: 13.144.185/0001-50 MODA HOME S.A.S. SIC 900.495.729 （株）ITXジャ パン (0120-914-075) #RN 138445 ZARA HOME CANADA INC. 1550 MONTRÉAL, QUEBEC, H3B 4G7 MA-MAROC : Sté RTW MAROC IF : 1642262.</div>
        <div style={{ display: 'block',letterSpacing:"-0.3px",marginBottom:7}}>
      {data.country.translate
        .map((item) => item.translation)
        .join(' / ')}
    </div>
    <div><Ceramic width="45.531mm" height="auto"/></div>
        
        </div>
        <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
           
                  <div></div>
               
        
    
         
             
        
                      <div style={{position:"absolute",top:122,height:29,left:40,width:"165px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                      <p className="arial-bold"
                        style={{
                          fontSize: "13.3px",
                          lineHeight: "19.7px",
                          letterSpacing: "0px",
                          color: "black",
                        }}
                      >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                         <p className="arial-bold"
                        style={{
                          fontSize: "13.3px",
                          lineHeight: "19.7px",
                          letterSpacing: "0px",
                          color: "black",
                          marginLeft:5.4
                        }}
                      >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                      </div>
          
                 
                  <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
                  {SelectedComponent && (
          <SelectedComponent.component
            width={SelectedComponent.width}
            height={SelectedComponent.height}
          />
        )}
        </div>
        
   
             
         
                  <div style={{   position: 'absolute',
    top: -15,
    right: rifd ? -44 : -37 }}>
                    <QRCodeComponent  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                    {modifiedSvgText && (
                      <div
          dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
        
        ></div>
        
              )}
                  </div>
          
               
           
                  <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                    <Barcode
                      value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                      format="ITF14"
                      width={0.921}
                      height={25.9}
                      marginLeft={1}
                      marginRight={1}
                      marginTop={1}
                      marginBottom={1}  
                      background="transparent"
                      lineColor={isBlack ? '#ffffff' : '#000000'}
                      textMargin={0}
                      fontSize={8} // 7pt yaklaşık olarak 9px
                      font="Arial"
                    />
                  </div>
        
         
                  <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                        ART
                      </p>  
                      <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                        .:
                      </p>
                      <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                      {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                      </p>
                    </div>{' '}
                  </div>
                </div>
              </div>
            </div>
            );
          

      default:
        // Eğer cardType yoksa veya tanınmıyorsa, mevcut renderShape'i kullan
        <></>
    }
  };
  

  return (
    <div>
    {renderCardTypeContent()}
    </div>
  )
}
